export default __webpack_public_path__ + "static/media/tratamientos-rejuvenecimiento.5c2f6fc0.png";